<template>
  <div class="bg-f">
    <!--公共头部-->
    <Header></Header>
    <!-- 用户中心头部 -->
    <user-header />
    <!-- 内容 -->
    <div class="main-content">
      <div class="container">
        <!-- <div class="my-order01">
          <span>首页</span>
        </div> -->
        <div class="accout-content clearfix" style="display:flex">
          <!-- 左边 -->
          <user-left mark="info"  :userId="userId"/>
          <!-- 右边 -->
          <a-card :bordered="false" class="card-right">
            <div class="one">{{ $t('user.info') }}</div>
            <div class="two">
              <div>
                <span>{{ $t('user.info.en') }}:</span>&nbsp;
                <span>{{list.companyNameEn}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.zh') }}:</span>&nbsp;
                <span>{{list.companyName}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.area') }}:</span>&nbsp;
                <span>{{list.countryName}}</span>
              </div>
              <!-- <div>
                <span>经营模式:</span>&nbsp;
                <span>Manufacturer丨Trading Company</span>
              </div> -->
              <div>
                <span>{{ $t('user.info.address-zh') }}:</span>&nbsp;
                <span>{{list.address}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.address-en') }}:</span>&nbsp;
                <span>{{list.addressEn}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.company-tel') }}:</span>&nbsp;
                <span>{{list.companyPhone}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.website') }}:</span>&nbsp;
                <span>{{list.website}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.contact-tel') }}:</span>&nbsp;
                <span>{{list.flPhone}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.fax') }}:</span>&nbsp;
                <span>{{list.fax}}</span>
              </div>
              <!-- <div>
                <span>时区:</span>&nbsp;
                <span>+8</span>
              </div> -->
            </div>
            <div class="one">{{ $t('user.info.contact') }}</div>
            <div class="three">
              <div>
                <span>{{ $t('user.info.first-name') }}:</span>
                <span>{{list.firstName}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.last-name') }}:</span>
                <span>{{list.lastName}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.chinese-name') }}:</span>
                <span>{{list.chName}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.gender') }}:</span>
                <span>{{list.sex == 0 ? $t('user.info.gender-0') : (list.sex == 1 ? $t('user.info.gender-1') : $t('user.info.gender-2'))}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.tel') }}:</span>
                <span>{{list.phone}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.position') }}:</span>
                <span>{{list.position}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.email') }}:</span>
                <span>{{list.email}}</span>
              </div>
              <div>
                <span>{{ $t('user.info.wechat') }}:</span>
                <span>{{list.wechatAccount}}</span>
              </div>
            </div>
            <div class="one">{{ $t('user.info.business') }}</div>
            <div class="four">{{ $t('user.info.main-zh') }}:</div>
            <div class="four">{{list.mainProducts}}</div>
            <div class="four">{{ $t('user.info.main-en') }}:</div>
            <div class="four">{{list.mainProductsEn}}</div>
            <div class="four">{{ $t('user.info.price-terms') }}:</div>
            <div class="four">{{list.tradeTerms}}</div>
            <div class="four">{{ $t('user.info.desc-zh') }}:</div>
            <div class="five">{{list.companyDesc}}</div>
            <div class="four">{{ $t('user.info.desc-en') }}:</div>
            <div class="five">{{list.companyDescEn}}</div>
            <div class="four">{{ $t('user.info.qualification') }}:</div>
            <div class="nine">
              <div v-for="(item,index) in list.images" :key="index">
                <img :src="item" alt="">
              </div>
            </div>
            <div class="four">{{ $t('user.info.company-logo') }}:</div>
            <div class="six">
              <img :src="list.logo" alt="">
            </div>
            <div class="four">{{ $t('user.info.company-img') }}:</div>
            <div class="six">
              <img :src="list.companyThumb" alt="">
            </div>
            <div class="four">{{ $t('user.info.index-banner') }}:</div>
            <div class="six">
              <img :src="list.indexThumb" alt="">
            </div>
            <div class="four">{{ $t('user.info.company-video') }}:</div>
            <div class="seven">
              <video :src="list.videoUrl" controls="controls" class="video"></video>
            </div>
            <!-- <div class="four">企业VR:</div>
            <div class="four">
              <a href="http://www.baidu.com">http://www.baidu.com</a>
            </div> -->
            <div class="four">{{ $t('user.info.pro-category') }}:</div>
            <div class="eight">
                <span v-for="(item,index) in list.companyCategorys" :key="index">{{item.categoryName}}</span>
            </div>
            <div class="eight">
              <router-link :to="{ name: 'InfoEdit' ,params: { userId: userId }}">
                <a-button type="primary">{{ $t('user.edit') }}</a-button>
              </router-link>
            </div>
          </a-card>
        </div>
      </div>
    </div>
    <!-- 公共尾部 -->
    <Footer></Footer>
   </div>
</template>

<style>
  .one{
    font-size: 24px;
    margin: 20px 0 0 20px;
    text-align: left;
  }
  .ant-card-body>.one:nth-child(1){
    margin-top: 0;
  }
  .two,.three{
    display: flex;
    flex-wrap: wrap;
    border-bottom: 1px solid #eee;
  }
  .two>div{
    width: 47%;
    text-align: left;
    margin: 10px 0 10px 20px;
  }
  .three>div{
    width: 30%;
    text-align: left;
    margin: 10px 0 10px 20px;
  }
  .three>div>span:nth-child(2){
    margin-left: 10px;
  }
  .four{
    text-align: left;
    margin: 20px 0 0 20px;
  }
  .five{
    background-color: #ddd;
    margin: 20px 0 0 20px;
    text-align: left;
  }
  .six{
    width: 200px;
    height: 200px;
    text-align: left;
    margin: 20px 0 0 20px;
  }
  .six img{
    width: 100%;
    height: 100%;
  }
  .seven{
    width: 320px;
    height: 180px;
    text-align: left;
    margin: 20px 0 0 20px;
  }
  .video{
    width: 320px;
    height: 180px;
  }
  .eight{
    text-align: left;
    margin: 20px 0 0 20px;
  }
  .eight>span{
    margin-left: 10px;
  }
  .eight>span:nth-child(1){
    margin-left: 0;
  }
  .nine{
    text-align: left;
    margin: 20px 0 0 20px;  
    display: flex;
  }
  .nine>div{
    width: 180px;
    height: 180px;
  }
  .nine>div>img{
    width: 100%;
    height: 100%;
  }
</style>

<script>
import UserHeader from './components/Header'
import UserLeft from './components/Left'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Editor from '@/components/Editor/TinyMceEditor'
export default {
  name: 'UsersIndex',
  components: {
    UserHeader,
    Footer,
    UserLeft,
    Editor,
    Header
  },
  data () {
    return {
        info: {

        },
        value: 1,
        radioStyle: {
          display: 'block',
          height: '30px',
          lineHeight: '30px',
        },
        userId: this.$route.params.userId,
        list: [],
        companyCategorys: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    onChange(e) {
      console.log('radio checked', e.target.value);
    },
    // 获取账号信息
    getList () {
       this.$common.fetchList('/user/account/info', {}).then(data => {
        if (data.code === 200) {
          const result = data.datas
          this.list = result
        }
      }).catch(() => {
        this.$notification.error({
          message: '错误',
          description: '请求信息失败，请重试'
        })
      })
    },
  }
}
</script>